'use strict';

var React = require('react');

var SvgReturnsMajor = function SvgReturnsMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15 11.25v-3.25h-10v6.75c0 .138.112.25.25.25h4a.75.75 0 0 1 0 1.5h-4a1.75 1.75 0 0 1-1.75-1.75v-6.863c0-.57.177-1.125.506-1.59l1.309-1.848a2.25 2.25 0 0 1 1.836-.949h5.796a2.25 2.25 0 0 1 1.872 1.002l1.22 1.828c.3.452.461.983.461 1.526v3.394a.75.75 0 0 1-1.5 0Zm-8.461-5.934a.75.75 0 0 1 .612-.316h2.099v1.5h-3.55l.839-1.184Zm7.81 1.184h-3.599v-1.5h2.197a.75.75 0 0 1 .624.334l.778 1.166Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 10a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-3Zm1.5.5v2h3v-2h-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 13a.75.75 0 0 0-1.5 0v.5a1.75 1.75 0 0 1-1.75 1.75h-.94l.22-.22a.75.75 0 1 0-1.06-1.06l-1.5 1.5a.75.75 0 0 0 0 1.06l1.5 1.5a.75.75 0 1 0 1.06-1.06l-.22-.22h.94a3.25 3.25 0 0 0 3.25-3.25v-.5Z"
  }));
};
SvgReturnsMajor.displayName = "ReturnsMajor";

exports.SvgReturnsMajor = SvgReturnsMajor;
